"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ErrorMessage = function ErrorMessage(_ref) {
  var message = _ref.message,
    theme = _ref.theme,
    errorLabel = _ref.errorLabel,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? '' : _ref$role;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, message && /*#__PURE__*/_react["default"].createElement("p", {
    className: _constructedForm["default"].errorMsg + " " + theme.smallType + " " + _constructedForm["default"].showMsg,
    id: errorLabel,
    role: role
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _constructedForm["default"].errorIcon,
    src: "data:image/svg+xml,%3Csvg width='11' height='10' viewBox='0 0 11 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 9.5h11L5.5 0 0 9.5zM6 8H5V7h1v1zm0-2H5V4h1v2z' fill='%23ED0000' fill-rule='nonzero'/%3E%3C/svg%3E"
  }), message));
};
ErrorMessage.displayName = 'ErrorMessage';
ErrorMessage.defaultProps = {
  message: 'default error',
  errorLabel: 'label',
  theme: {}
};
var _default = ErrorMessage;
exports["default"] = _default;